import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/** clsx でクラスを結合し、twMerge で Tailwind の競合を解決する */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
